<h2 class="inline">Simulation</h2><br>
<div class="inline" style="max-width:200px">
    <sa-input-text class="inline" [(text)]="scenarioid" [title]="'Enter Scenario Number'" [required]="'none'"></sa-input-text>
</div>
<div *ngFor="let s of scenariosensors" style="max-width:400px">
    <div style="width:20%;display:inline-block;text-align:center;margin:20px">{{s.sensorname}}:</div> 
    <div style="width:40%;border:solid 1px gray;display:inline-block;text-align:center;margin:20px">{{s.reading | number: '1.1-1'}}</div><br>
</div>
<button class="btn btn-primary inline" (click)="debug = false; start()">Start</button>
<button class="btn btn-primary inline" (click)="stop()">Stop</button>
<br>
Debug={{debug}}, Counter: {{counter}}, Distance: {{distance | number: '1.1-1'}}, in contour 
<span *ngIf="scenariolayout.contours.length > 0">{{currentContourId}}, value{{scenariolayout.contourdefinitions[currentContourId].exposure}}</span>
<div #pagemap style="width:100%;height:400px"></div>
<button class="btn btn-primary inline" (click)="debug = true; start()">Simulate GPS</button>
